module.exports = __webpack_public_path__ + "static/media/card_02.2f66231a.png";